module.exports = __webpack_public_path__ + "static/logo-633a98cf2469431c95cf34b55ed1040a.png";